exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ltui-panel.ltui-form[data-v-6b5df7b5] .ltui-panel__content{overflow:hidden!important}", ""]);

// exports
